import { WWW_ORIGIN } from '../config';

export default class Account {
  public getMe = () =>
    fetch(`${WWW_ORIGIN}/partner-payments/api/partners`, {
      credentials: 'include',
      headers: { Cookie: document.cookie },
    })
      .then((res) => res.json())
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      .catch(() => {});

  public getStripeUser = () =>
    fetch(`${WWW_ORIGIN}/partner-payments/api/stripe/stripe_account`, {
      credentials: 'include',
      headers: { Cookie: document.cookie },
    }).then((res) => {
      if (res.ok) {
        return res.json();
      }
      throw new Error('No user found');
    });

  public createCard = (payload: any) =>
    fetch(`${WWW_ORIGIN}/partner-payments/api/stripe/stripe_card`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        Cookie: document.cookie,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    }).then((res) => {
      if (res.ok) {
        return res.json();
      }
      throw new Error('An error occurred');
    });

  public createStripeAccount = (payload: any) =>
    fetch(`${WWW_ORIGIN}/partner-payments/api/stripe/stripe_account`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        Cookie: document.cookie,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
}
